<template>
    <div >
        <v-sheet v-if="loading" class="mx-auto" style="background-size:cover;cursor:pointer;position:relative;" height="284" width="204" dark>
            <v-skeleton-loader
                    light

                    class="mx-auto"
                    type="image"
                    style="z-index:1;position:absolute;width: 165px; top: 32px; left: 20px; height: 120px;"
            ></v-skeleton-loader>

        </v-sheet>

        <v-card
                v-show="!loading"
                flat
                max-width="204"
                style="background:transparent !important;"
                @click="clicked"
                class="mx-auto"
                min-width="204"
        >

            <v-card-text @mouseleave="unlift" @mouseover="lift"  class="pb-0 pa-0">
                <img class="plastic_cover" v-if="plastic_1 && this.$vuetify.breakpoint.mdAndUp" style="position:absolute;z-index: 10;width:240px;opacity:0.3;top: 40px; left: -15px;height:250px;" :src="require('../assets/plastic/pocket8_pack.png')"/>
                <img class="plastic_cover" v-if="!plastic_1 && this.$vuetify.breakpoint.mdAndUp" style="position:absolute;z-index: 10;width:240px;opacity:0.3;top: 40px; left: -15px;height:250px;" :src="require('../assets/plastic/pocket9_pack.png')"/>
                <v-card @load="onImgLoad" :class="animation" elevation="20" dark raised  :style="{ backgroundImage: `url('${background_image}')`}" style="background-size:cover !important;cursor:pointer;background:transparent;" height="284" width="204">



                </v-card>

            </v-card-text>
            <v-card-actions style="position:relative;z-index: -1;" :style="{'top':$vuetify.breakpoint.mdAndUp? '-50px':'10px'}" class="pa-0 mt-0">

                <v-btn

                        tile
                        small
                        style="font-size:10px;"

                        depressed


                        class="mx-auto"
                >
                    <b>{{data.NAME}}</b>
                </v-btn>




            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
    export default {
        name: "Pack",
        data(){
            return{
                loading:true,
                animation:"unlift",
                isAnimating:false

            }
        },
        props: {
            "data":Object,
            "editable":Boolean,
            "list_index":Number

        },


        computed:{
            plastic_1:function(){
                return Math.random() >= 0.5;


            },
            background_image:function(){
                let img = new Image();
                let self=this;
                img.onload = function(){
                    self.loading=false;

                };

                img.src = `/api/images/cards/collections/${this.data.COLLECTION}/pack.png`

                return img.src


            }




        },

        methods:{
            unlift:function(){
                if(!this.isAnimating){
                    this.animation="unlift";
                }
                else{
                    let self=this;
                    setTimeout(function(){
                        self.animation="unlift";
                    },300)
                }
            },
            lift:function(){
                this.animation="lift";
                this.isAnimating=true;
                let self=this;
                setTimeout(function(){
                    self.isAnimating=false;
                },300)
            },
            clicked:function(){
                this.$emit('clicked',this.data,this.list_index)




            },
            onImgLoad(){
                this.loading=false
            }

        }
    }
</script>

<style scoped>
    .unlift {
        transform: translateY(0);
        transition: transform .2s;
        background-size: cover !important;
    }

    .lift {
        transform: translateY(-80px) rotate(2deg);
        transition: transform .2s;
        background-size: cover !important;
    }

</style>
